export enum ChainId {
    MAINNET = 1,
    ROPSTEN = 3,
    RINKEBY = 4,
    GÖRLI = 5,
    KOVAN = 42,
    ARBITRUM_ONE = 42161,
    ARBITRUM_RINKEBY = 421611,
    OPTIMISM = 10,
    OPTIMISTIC_KOVAN = 69,
    BSC = 56,
    BSC_TESTNET = 97,
    INDRA_TESTNET = 222,
    // MATIC = 137,
    // MATIC_TESTNET = 80001,
    // FANTOM = 250,
    // FANTOM_TESTNET = 4002,
    // XDAI = 100,
    // MOONBEAM_TESTNET = 1287,
    // AVALANCHE = 43114,
    // AVALANCHE_TESTNET = 43113,
    // HECO = 128,
    // HECO_TESTNET = 256,
    // HARMONY = 1666600000,
    // HARMONY_TESTNET = 1666700000,
    // OKEX = 66,
    // OKEX_TESTNET = 65,
    // CELO = 42220,
  }